import styled from "styled-components";
import { BiDetail, BiExport } from "react-icons/bi";
import { GoLocation } from "react-icons/go";
import { FaSignature } from "react-icons/fa";
import goTo from "../../../../controllers/goTo";
import exportFunction from "../../../../controllers/customControllerForCS/exportFunction";
import NomenclatureOfSite from "../nomenclature/NomenclatureOfSite";
import LoggedInBoilerplate from "../LoggedInBoilerplate";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
  margin-top: 30px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Content = styled.div`
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--surface2);
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

let siteExportColumns = [
  "Client Name",
  "Place Name",
  "Zone Name",
  "Longitude",
  "Latitude",
  // "Number Of Agents",
  "Is Active",
  "Contract End Date",
  "Contacts",
  // "Name Of Contact 1",
  // "Number Of Contact 1",
  // "Name Of Contact 2",
  // "Number Of Contact 2",
  // "Name Of Contact 3",
  // "Number Contact 3",
  "Date Of Implementation",
  "Address Locality",
  "Address Street",
  "Direction To Follow",
  "Special Instructions",
];
let siteContractExportColumns = [
  "Client Name",
  "Place Name",
  "Zone Name",
  "Contracts",
];
let siteAssistanceExportColumns = [
  "Client Name",
  "Place Name",
  "Zone Name",
  "Assistance",
];

export default function SiteListPage() {
  return (
    <LoggedInBoilerplate titleLine1={"Liste des"} titleLine2={"Sites"}>
      <NomenclatureOfSite
        columns={2}
        buttons={[
          {
            icon: <GoLocation />,
            text: "Ajouter un site",
            onClick: goTo("/add-site"),
          },
          {
            icon: <BiExport />,
            text: "Exporter",
            permissionName: "siteExportPermissions",
            onClick: exportFunction({
              title: "Exporter",
              path: "/sites/?forExport=true",
              selectedFields: siteExportColumns,
              autoDownloadExcel: true,
            }),
          },
          {
            icon: <FaSignature />,
            text: "Exporter Contrats",
            permissionName: "siteExportContractPermissions",
            onClick: exportFunction({
              title: "Exporter Contrats",
              path: "/sites/?forExport=true&shouldHaveContract=true",
              selectedFields: siteContractExportColumns,
              autoDownloadExcel: true,
            }),
          },
          {
            icon: <BiDetail />,
            text: "Exporter Assistance",
            permissionName: "siteExportAssistancePermissions",
            onClick: exportFunction({
              title: "Exporter Assistance",
              path: "/sites/?forExport=true&shouldHaveAssistance=true",
              selectedFields: siteAssistanceExportColumns,
              autoDownloadExcel: true,
            }),
          },
        ]}
      />
    </LoggedInBoilerplate>
  );
}
